var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"question-page"},[_c('navBar',{on:{"goBack":_vm.gobackChapter}},[_c('span',{staticClass:"title"},[_vm._v("高考链接")])]),_c('questionList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }